var map = {
	"./currentFlow/bulbs.jpg": "5cae",
	"./currentFlow/electricity.jpg": "138c",
	"./currentFlow/figure1.jpg": "6221",
	"./currentFlow/figure2.jpg": "49e9",
	"./pancakes/pancakes.jpg": "13c2",
	"./wishKnew/bitbytes.jpg": "b912",
	"./wishKnew/rockhorse.jpg": "e93f",
	"./wishKnew/titleImage.jpg": "5f57",
	"./wishKnew/trojan.jpg": "ae46"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3540";